import { BackInStockSubscriberSchema } from "@redotech/redo-model/customer-product-notification/customer-product-notification";
import * as z from "zod/v4";

export const getBackInStockSubscribers = {
  name: "getBackInStockSubscribers" as const,
  input: z.object({
    productId: z.string(),
    variantId: z.string(),
    status: z.enum(["all", "waiting", "notified"]).optional(),
  }),
  output: z.object({
    subscribers: z.array(BackInStockSubscriberSchema),
    totalCount: z.number(),
  }),
};
